import React, { FC, useContext, useEffect } from "react";
import styles from "./OnBorading.module.css";
import { Link, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../contexts/GlobalContext";
import GoogleIcon from "../../assets/icons/google_icon";

interface OnBoradingProps {}

const OnBorading: FC<OnBoradingProps> = () => {
  const navigate = useNavigate();

  const { logInWithGoogle, logOut, currentUser, getCurrentUser } =
    useContext(GlobalContext);

  useEffect(() => {
    if (getCurrentUser() !== null) {
      navigate("/home");
    }
    // console.log("Current User: ", getCurrentUser());
  }, [getCurrentUser, navigate]);

  return (
    <>
      <div className="bg-custom-gradient min-h-screen w-full flex flex-col justify-between px-6">
        {/* Heading at the Top */}
        <h1 className="font-soria text-[#045B01] text-[4em] text-center mx-8 leading-tight mt-10">
          Let's Begin Your Quran Journey
        </h1>

        {/* Button at the Bottom */}
        <div className="w-full flex justify-center mb-24">
          <Link
            to="/login"
            className="w-full flex items-center justify-center px-6 py-4 bg-[#3A9437] rounded-full cursor-pointer"
          >
            <p className="font-grgrifter text-2xl tracking-wider text-center text-white">
              Bismillah!
            </p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default OnBorading;
